export const PAGONLINE_GET_DETALLE_PAGO='PAGONLINE_GET_DETALLE_PAGO';
export const PAGONLINE_GET_DETALLE_PAGO_SUCCESS='PAGONLINE_GET_DETALLE_PAGO_SUCCESS';